module.exports = __webpack_public_path__ + "static/media/24-ic-close.4d7fd690.svg";